/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import TBody from '../../components/table/TBody/TBody';
import TD from '../../components/table/TD/TD';
import TR from '../../components/table/TR/TR';
import { BASE_URL } from '../../core/constants/api';
import Table from '../../components/table/Table';
import Image from '../../components/image/Image';
import TH from '../../components/table/TH/TH';
import THead from '../../components/table/THead/THead';
import TableWrapper from '../components/table-wrapper/TableWrapper';
import { RootState } from '../../core/state/state';
import NoResultsPage from '../../components/no-results-page/NoResultsPage';
import { getInternalUsersByProjectId } from '../../core/state/project/asyncActions';
import { getInternalUsers } from '../../core/state/users/asyncActions';
import { InternalUser, InternalUserFilter } from '../../core/state/users/types';
import defaultUserImage from '../../../img/user-default.png';
import { UserRoleType } from '../../core/state/user/types';

import './ProjectInternalRoles.scss';

const ProjectInternalRoles: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const users = useSelector((state: RootState) => state.projects.internalUsers);
  const allUsers = useSelector((state: RootState) => state.users.internalUsers);
  const { projectId } = useParams<{ projectId: string }>();

  React.useEffect(() => {
    dispatch(getInternalUsersByProjectId(Number(projectId)));
    dispatch(getInternalUsers(InternalUserFilter.All));
  }, []);

  const getUserRole = (user: InternalUser) => {
    const userRole = allUsers?.find((f) => f.id === user.id)?.roleName;
    return userRole;
  };

  const hasVisibleRole = (user: InternalUser) => {
    return (
      (getUserRole(user) === UserRoleType.SystemUser && user.roleName === 'ProjectAdmin') ||
      (getUserRole(user) === UserRoleType.SystemUser && user.roleName === 'ProjectParticipant')
    );
  };

  return (
    <TableWrapper>
      <div className="table__header">
        <span>{t('internalUsers.roles.title')}</span>
      </div>
      <div className="project-internal-roles__table">
        <Table>
          <THead>
            <TR>
              <TH>{t('internalUsers.heading.name')}</TH>
              <TH>{t('common.userRole')}</TH>
              <TH>{t('common.email')}</TH>
              <TH>{t('common.phone')}</TH>
              <TH>{t('internalUsers.heading.landline')}</TH>
              <TH>{t('internalUsers.heading.position')}</TH>
              <TH>{t('internalUsers.heading.area')}</TH>
            </TR>
          </THead>
          <TBody>
            {users?.filter(hasVisibleRole).map((user, i) => (
              <TR className="project-internal-roles__user" key={`${i}-${user.id}`}>
                <TD className="d-flex align-items-center">
                  <Image
                    className="project-internal-roles__user-img"
                    src={`${BASE_URL}/${user.profilePhoto}`}
                    alt="user avatar"
                    onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
                      e.currentTarget.src = defaultUserImage;
                    }}
                  />
                  <span className="font-weight-bold">{`${user.firstName} ${user.lastName}`}</span>
                </TD>
                <TD className="text-left">{user.roleName}</TD>
                <TD className="text-left">{user.email}</TD>
                <TD className="text-left">{user.mobilePhoneNumber ?? '--'}</TD>
                <TD className="text-left">{user.phoneNumber ?? '--'}</TD>
                <TD className="text-left">{user.title ?? '--'}</TD>
                <TD className="text-left">{user.areaName ?? '--'}</TD>
              </TR>
            ))}
          </TBody>
        </Table>
        {!users && (
          <NoResultsPage
            title={t('common.noUsers')}
            description={t('internalUsers.noResults.description')}
            icon="profile"
            iconClass="project-internal-roles__no-results-icon"
          />
        )}
      </div>
    </TableWrapper>
  );
};

export default ProjectInternalRoles;
